// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetClustersForMapRequest,
  TGetClustersForMapModel,
  IMappers,
  TGetClustersForMapResponse_,
  TGetClustersForMapResponse,
  TGetClustersForMapResponse_1,
  TGetClustersForMapResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createGetClustersForMapModel(parameters: TGetClustersForMapRequest): TGetClustersForMapModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-offers-index',
    pathApi: '/v2/get-clusters-for-map/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetClustersForMapOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetClustersForMapRequest;
}

export async function fetchGetClustersForMap<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetClustersForMapOptions<TResponse200, TResponse400>): Promise<
  TGetClustersForMapResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetClustersForMapModel(parameters),
    config,
  )) as FetchResponse<TGetClustersForMapResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetClustersForMapResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetClustersForMapResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TGetClustersForMapResponse;
}
